export default __webpack_public_path__ + "static/media/SupportDesk.68d09f2f.png";